/**
 * Desk clock offset for developer time warp.
 * Offset 0 is the real clock. Callers that already pass `now` are unchanged.
 */

let offsetMs = 0;

export function appClockOffsetMs(): number {
  return offsetMs;
}

export function setAppClockOffsetMs(ms: number): number {
  if (!Number.isFinite(ms)) return offsetMs;
  offsetMs = Math.trunc(ms);
  return offsetMs;
}

export function shiftAppClock(ms: number): number {
  return setAppClockOffsetMs(offsetMs + ms);
}

export function resetAppClock(): number {
  offsetMs = 0;
  return 0;
}

/** Real time plus the developer offset. */
export function appNow(real: Date = new Date()): Date {
  if (!offsetMs) return real;
  return new Date(real.getTime() + offsetMs);
}
